/**
 * WordPress dependencies.
 */
import { __,_x } from '@wordpress/i18n';

import {InspectorControls} from '@wordpress/block-editor';

import {
    Fragment
} from '@wordpress/element';

import SlideItemSettingPanel from './settings/index.js';

const InsSettings = (props) => {
      
    return (
        <Fragment>
                <InspectorControls>
					<Fragment>
                    <SlideItemSettingPanel {...props} />
					</Fragment>
                 </InspectorControls>
        </Fragment>
               
        )
}
export default InsSettings;